"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeParachainRequest = exports.storageKeyToFirstInner = exports.encodeUnsignedFixedPoint = exports.decodeFixedPointType = exports.uint8ArrayToString = exports.reverseEndiannessHex = exports.stripHexPrefix = exports.reverseEndianness = void 0;
const _1 = require(".");
const big_js_1 = __importDefault(require("big.js"));
/**
 * Converts endianness of a Uint8Array
 * @param bytes Uint8Array, to be converted LE<>BE
 */
function reverseEndianness(bytes) {
    let offset = bytes.length;
    for (let index = 0; index < bytes.length; index += bytes.length) {
        offset--;
        for (let x = 0; x < offset; x++) {
            const b = bytes[index + x];
            bytes[index + x] = bytes[index + offset];
            bytes[index + offset] = b;
            offset--;
        }
    }
    return bytes;
}
exports.reverseEndianness = reverseEndianness;
function isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/**
 * Remove the `0x` hex prefix if present
 * @param str
 */
function stripHexPrefix(str) {
    return isHexPrefixed(str) ? str.slice(2) : str;
}
exports.stripHexPrefix = stripHexPrefix;
/**
 * Reverse the endianness of the given hex string
 * @dev Will remove `0x` prefix if present
 * @param hex
 */
function reverseEndiannessHex(hex) {
    const arr = stripHexPrefix(hex).match(/.{1,2}/g) || [];
    const bytes = new Uint8Array(arr.map((byte) => parseInt(byte, 16)));
    return reverseEndianness(bytes).reduce((str, byte) => str + byte.toString(16).padStart(2, "0"), "");
}
exports.reverseEndiannessHex = reverseEndiannessHex;
/**
 * Converts a Uint8Array to string
 * @dev Will remove `0x` prefix if present
 * @param bytes
 */
function uint8ArrayToString(bytes) {
    return stripHexPrefix(bytes.toString()).split("").join("");
}
exports.uint8ArrayToString = uint8ArrayToString;
function decodeFixedPointType(x) {
    const xBig = new big_js_1.default(x.toString());
    const scalingFactor = new big_js_1.default(Math.pow(10, _1.FIXEDI128_SCALING_FACTOR));
    const xDecoded = xBig.div(scalingFactor);
    return xDecoded.toString();
}
exports.decodeFixedPointType = decodeFixedPointType;
function encodeUnsignedFixedPoint(api, x) {
    const xBig = new big_js_1.default(x);
    const scalingFactor = new big_js_1.default(Math.pow(10, _1.FIXEDI128_SCALING_FACTOR));
    const xScaled = xBig.mul(scalingFactor);
    return api.createType("FixedU128", xScaled.toFixed());
}
exports.encodeUnsignedFixedPoint = encodeUnsignedFixedPoint;
function storageKeyToFirstInner(s) {
    return s.args[0];
}
exports.storageKeyToFirstInner = storageKeyToFirstInner;
function encodeParachainRequest(req, network) {
    return Object.assign(Object.assign({}, req), { btc_address: _1.encodeBtcAddress(req.btc_address, network) });
}
exports.encodeParachainRequest = encodeParachainRequest;
//# sourceMappingURL=encoding.js.map